import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { KtLogsGridDataService } from 'common/services/data-services/admin/kt/kt-logs.data.service';
import { KtLogsGridMetaModel } from 'common/models/page-models/kt-logs/kt-logs-grid-meta-model';
import { KtLogsListingModel } from 'common/models/page-models/kt-logs/kt-logs-grid.model';
import { KtLogsModel } from 'common/models/page-models/kt-logs/kt-logs-model';



@Injectable({
    providedIn: 'root'
})
export class KTLogsGridWidgetService extends GridWidgetService<KtLogsModel, KtLogsListingModel> {
    constructor(protected override ds: KtLogsGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new KtLogsGridMetaModel().getMetaModel();
        return meta;
    }
}